import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class EventModel extends Model 
{
	@attr name;
	@attr date;
	@attr venue;
	@attr location;
	@attr text1;
	@attr text2;
	@attr text3;
	@attr text4;
	@attr text5;
	@attr('boolean') usePhotoFinish;
	@attr('boolean') useIndividualCourses;
	@attr startImpulseEarlyMargin;
	@attr startImpulseLateMargin;
	@attr precision;
	@attr id1Name;
	@attr id2Name;
	@attr id3Name;
	@attr pts1Name;
	@attr pts2Name;
	@attr pts3Name;
	@attr pts4Name;
	@attr pts5Name;
	@attr racePts1Name;
	@attr racePts2Name;
	@attr racePts3Name;
	@attr racePts4Name;
	@attr racePts5Name;
	@attr classGroupId1Name;
	@attr classGroupId2Name;
	@attr classGroupId3Name;
	@attr classGroupWeather1Name;
	@attr classGroupWeather2Name;
	@attr classGroupWeather3Name;
	@attr classGroupPts1Name;
	@attr classGroupPts2Name;
	@attr classGroupPts3Name;
	@attr classGroupPts4Name;
	@attr classGroupPts5Name;
	@attr text1Name;
	@attr text2Name;
	@attr text3Name;
	@attr text4Name;
	@attr text5Name;
	@attr entryText1Name;
	@attr entryText2Name;
	@attr entryText3Name;
	
	@hasMany('entry', {inverse: 'EventId', async: true}) entries;
	@hasMany('team', {inverse: 'EventId', async: true}) teams;
	@hasMany('intermediate-timing-point', {inverse: 'EventId', async: true}) intermediateTimingPoints;
	@hasMany('start-timing-record', {inverse: 'EventId', async: true}) startTimingRecords;
	@hasMany('finish-timing-record', {inverse: 'EventId', async: true}) finishTimingRecords;
	@hasMany('tie-timing-record', {inverse: 'EventId', async: true}) tieTimingRecords;
	@hasMany('penalty-timing-record', {inverse: 'EventId', async: true}) penaltyTimingRecords;
	@hasMany('intermediate-timing-record', {inverse: 'EventId', async: true}) intermediateTimingRecords;
	@hasMany('result', {inverse: 'EventId', async: true}) results;
	@hasMany('team-result', {inverse: 'EventId', async: true}) teamResults;
	@hasMany('class', {inverse: 'EventId', async: true}) classes;
	@hasMany('class-group', {inverse: 'EventId', async: true}) classGroups;
	@hasMany('course', {inverse: 'EventId', async: true}) courses;
	@hasMany('timing-impulse', {inverse: 'EventId', async: true}) timingImpulses;
	@hasMany('jury-member', {inverse: 'EventId', async: true}) juryMembers;
	@hasMany('segment', {inverse: 'EventId', async: true}) segments;
	
	get classesM()
	{
		return this.get('classes').then((classes) => (classes.slice().filter((ec) => 
		{
			const gender = ec.gender;
			if(gender == null)
				return false;
			return gender == 'M' || gender == 'X';
		})));
	}
	get classesF()
	{
		return this.get('classes').then((classes) => (classes.slice().filter((ec) => 
		{
			const gender = ec.gender;
			if(gender == null)
				return false;
			return gender == 'F' || gender == 'X';
		})));
	}
	get classesX()
	{
		return this.get('classes').then((classes) => (classes.slice().filter((ec) => 
		{
			const gender = ec.gender;
			if(gender == null)
				return false;
			return gender == 'X';
		})));
	}
	
	//not saved to DB, used to control if autoassociation is running
	shouldAutoAssociateStart = false;
	shouldAutoAssociateFinish = false;
	shouldAutoAssociateIntermediate = false;
}